import { Link, useLocation, useNavigate } from "react-router-dom";
import React, { useState, useContext, useEffect, useRef } from "react";
import { useTransferSearch } from "./TransferSearchContext";
import { FaTelegramPlane } from "react-icons/fa";
import PhoneInput from "react-phone-input-2";
import ReCAPTCHA from "react-google-recaptcha";

const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

const UserDetailsForm = ({ vehicle_id, responcetype, singleprice, updatedpes , extras }) => {
  const tourDataNavigate = useNavigate();
  
const { searchData, resetSearchData } = useTransferSearch();
  //console.log(extras);
  const [succ, setsuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const backhome = useNavigate();
  const [formData, setFormData] = useState({
    passengerName: "",
    phone: "",
    flightDetails: "",
    email: "",
    specialRequirements: "",
  });
 
  const [isFormValid, setIsFormValid] = useState(false);
  const recaptchaRef = useRef(null);

  // Email validation function
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  
  // Overall form validation
  const validateForm = (data) => {
    if (!data) return;
  
    const { passengerName, phone, email } = data;
  
    const valid =
      passengerName.trim() !== "" &&
      phone.trim() !== "" &&
      isValidEmail(email);
  
    setIsFormValid(valid);
  };

  const handleInputChange2 = (name, value) => {
    const updatedForm = {
      ...formData,
      [name]: value,
    };
    setFormData(updatedForm); // assuming you're using this
  };
  
  
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
  
    const updatedForm = {
      ...formData,
      [name]: value,
    };
  
    if (name === "email") {
      if (!isValidEmail(value) && value !== "") {
       
      } else {
        
      }
    }
  
    setFormData(updatedForm);
    validateForm(updatedForm); // Re-validate the whole form
  };
  
  const handleButtonClick = () => {
    if (!isFormValid || isLoading) return;
    recaptchaRef.current.execute();
  };

  const handleSubmit = async (recaptchaToken) => {
    setIsLoading(true); // Show loader
    // API data structure based on provided sample
    if(responcetype == 'get_qoute'){
      const requestData = {
        vehicle_id: vehicle_id, // assuming vehicle_id is fixed
        user_name: formData.passengerName,
        no_of_pax: searchData.passengers,
        user_email: formData.email,
        user_phone: "+"+formData.phone,
        booking_date: new Date(searchData.date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }),
        booking_time: `${String(searchData.time.hour).padStart(2, '0')}:${String(searchData.time.minute).padStart(2, '0')}`, // from context
        flight_number: `${formData.flightDetails ? formData.flightDetails : '-'}`,
        requirements: `${formData.specialRequirements ? formData.specialRequirements : '-'}`,
        from_address: searchData.from.label, // from context
        to_address: searchData.to.label, // from context
        extra_luggage:extras.luggageQnt,
        surfboard:extras.surfboardQnt,
        baby_seats:extras.babySeatsQnt,
        baby_booster:extras.babyBoosterQnt,
        recaptcha_token: recaptchaToken
      };
     //console.log(requestData);
      try {
        const response = await fetch(
          "https://login.flymiles.com.au/api_sections/transafer/front_end/create_get_quote.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );
        const data = await response.json();
        //console.log(data);
        setsuccess(data.success);
        setTimeout(() => {
          backhome(`/`);
        }, 5000);
      
      
      } catch (error) {
        console.error("Error submitting form:", error);
      }finally {
        setIsLoading(false); // Hide loader regardless of success or error
        resetSearchData();
        recaptchaRef.current?.reset();
      }
    }

    if(responcetype == 'book_now'){
      const requestData = {
        vehicle_id: vehicle_id, // assuming vehicle_id is fixed
        user_name: formData.passengerName,
        no_of_pax: updatedpes,
        user_email: formData.email,
        user_phone: "+"+formData.phone,
        booking_date: new Date(searchData.date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }),      
        booking_time:`${String(searchData.time.hour).padStart(2, '0')}:${String(searchData.time.minute).padStart(2, '0')}`, // from context
        flight_number: `${formData.flightDetails ? formData.flightDetails : '-'}`,
        requirements: `${formData.specialRequirements ? formData.specialRequirements : '-'}`,
        from_address: searchData.from.label, // from context
        to_address: searchData.to.label, // from context
        price_single:singleprice,
        price_total:singleprice*updatedpes,
        pay_type: 'book_now',
        extra_luggage:extras.luggageQnt,
        surfboard:extras.surfboardQnt,
        baby_seats:extras.babySeatsQnt,
        baby_booster:extras.babyBoosterQnt,
        extra_luggage_price: extras.totalLuggagePrice,
        surfboard_price: extras.totalSurfboardPrice,
        baby_seats_price: extras.totalBabySeatsPrice,
        baby_booster_price: extras.totalBabyBoosterPrice,
        recaptcha_token: recaptchaToken
      };
     //console.log(requestData);
      try {
        const response = await fetch(
          "https://login.flymiles.com.au/api_sections/transafer/front_end/create_booking.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );
        const data = await response.json();
        //console.log(data);

        tourDataNavigate(`/transfer-booking-custom`, {
          state: { bookingid: data.booking_id , totalcharge: data.charge_amount},
        });


      } catch (error) {
        console.error("Error submitting form:", error);
      }finally {
        setIsLoading(false); // Hide loader regardless of success or error
        resetSearchData();
        recaptchaRef.current?.reset();
      }
    }
    if(responcetype == 'pay_later'){
      const requestData = {
        vehicle_id: vehicle_id, // assuming vehicle_id is fixed
        user_name: formData.passengerName,
        no_of_pax: updatedpes,
        user_email: formData.email,
        user_phone: "+"+formData.phone,
        booking_date: new Date(searchData.date).toLocaleDateString('en-GB', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        }),      
        booking_time: `${String(searchData.time.hour).padStart(2, '0')}:${String(searchData.time.minute).padStart(2, '0')}`, // from context
        flight_number: `${formData.flightDetails ? formData.flightDetails : '-'}`,
        requirements: `${formData.specialRequirements ? formData.specialRequirements : '-'}`,
        from_address: searchData.from.label, // from context
        to_address: searchData.to.label, // from context
        price_single:singleprice,
        price_total:singleprice*updatedpes,
        pay_type: 'pay_later',
        extra_luggage:extras.luggageQnt,
        surfboard:extras.surfboardQnt,
        baby_seats:extras.babySeatsQnt,
        baby_booster:extras.babyBoosterQnt,
        extra_luggage_price: extras.totalLuggagePrice,
        surfboard_price: extras.totalSurfboardPrice,
        baby_seats_price: extras.totalBabySeatsPrice,
        baby_booster_price: extras.totalBabyBoosterPrice,
        recaptcha_token: recaptchaToken
      };

     //console.log(requestData);
      try {
        const response = await fetch(
          "https://login.flymiles.com.au/api_sections/transafer/front_end/create_booking.php",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
          }
        );
        const data = await response.json();
        //console.log(data);

        tourDataNavigate(`/transfer-booking-custom`, {
          state: { bookingid: data.booking_id , totalcharge: data.charge_amount},
        });
      } catch (error) {
        console.error("Error submitting form:", error);
      }finally {
        setIsLoading(false); // Hide loader regardless of success or error
        resetSearchData();
        recaptchaRef.current?.reset();
      }
    }

  };




  useEffect(() => {
    //console.log('Validating form on data change...');
    validateForm(formData);
  }, [formData, searchData]);

  return (
    <>
      {isLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="loader border-t-4 border-white rounded-full w-12 h-12 animate-spin"></div>
        </div>
      )}
      <div className="border p-3 rounded-lg">
        <h2 className="font-semibold text-xl">Let us know who you are</h2>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex gap-2 pb-2 border-b w-full mt-4">
            <img
              className="h-10 w-10 object-contain"
              src="/assets/icons/user-list.png"
              alt="time"
            />
            <div className="w-full tour-date">
              <label
                className="text-[#626262] font-medium block mb-1"
                htmlFor="passengerName"
              >
                Passenger Name
              </label>
              <input
                type="text"
                name="passengerName"
                value={formData.passengerName}
                onChange={handleInputChange}
                placeholder="Name of passenger"
              />
            </div>
          </div>
          <div className="flex gap-2 pb-2 border-b w-full mt-4">
            <img
              className="h-10 w-10 object-contain"
              src="/assets/icons/call.png"
              alt="time"
            />
            <div className="w-full tour-date">
              <label
                className="text-[#626262] font-medium block mb-1"
                htmlFor="phone"
              >
                Phone
              </label>
              <PhoneInput
                required
                country={"au"} // You can set the default country code here
                value={formData.phone}
                onChange={(value) => handleInputChange2("phone", value)}
                inputStyle={{
                  width: "100%",
                  border: "none",
                  outline: "none",
                }}
                buttonStyle={{
                  border: "none",
                  outline: "none",
                }}

              />
              {/* <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleInputChange}
                placeholder="Phone number of passenger"
              /> */}
            </div>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="flex gap-2 pb-2 border-b w-full mt-4">
            <img
              className="h-10 w-10 object-contain"
              src="/assets/icons/plane.png"
              alt="time"
            />
            <div className="w-full tour-date">
              <label
                className="text-[#626262] font-medium block mb-1"
                htmlFor="flightDetails"
              >
                Flight Number / Cruise Details
              </label>
              <input
                type="text"
                name="flightDetails"
                value={formData.flightDetails}
                onChange={handleInputChange}
                placeholder="Flight number or cruise details"
              />
            </div>
          </div>
          <div className="flex gap-2 pb-2 border-b w-full mt-4">
            <img
              className="h-10 w-10 object-contain"
              src="/assets/icons/email.png"
              alt="time"
            />
            <div className="w-full tour-date">
              <label
                className="text-[#626262] font-medium block mb-1"
                htmlFor="email"
              >
                Email Address
              </label>
              <input
                type="email"
                name="email"
                required
                value={formData.email}
                onChange={handleInputChange}
                placeholder="Email of passenger"
              />
            </div>
          </div>
        </div>

        <div className="flex gap-2 pb-2 border-b w-full mt-4">
          <img
            className="h-10 w-10 object-contain"
            src="/assets/icons/remark.png"
            alt="time"
          />
          <div className="w-full tour-date">
            <label
              className="text-[#626262] font-medium block mb-1"
              htmlFor="specialRequirements"
            >
              Special Requirement
            </label>
            <textarea
              style={{ height: "80px" }}
              name="specialRequirements"
              value={formData.specialRequirements}
              onChange={handleInputChange}
              placeholder="Passenger's Messages"
              className="w-full"
              rows="1"
            />
          </div>
        </div>
        <br />
        {succ ? (
        <div className={"flex justify-start mt-4"}>
          <div className="bg-red-100 w-[100%] font-medium text-red-400 py-2 px-5 rounded-md" style={{ color: "green",background: "#cefcce"}}>
            {succ}
          </div>
        </div>
      ) : (
        <></>
      )}
        <br />
        <div className="mt-4">
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={RECAPTCHA_SITE_KEY}
          size="invisible"
          badge="bottomright"
          onChange={(token) => handleSubmit(token)}
        />
        <button
          style={{ marginLeft: 'auto', marginRight: 'auto',backgroundColor: "#73ab5c" }}
          onClick={handleButtonClick}
          disabled={!isFormValid}
          className={`flex mt-3 xl:mt-0 w-max items-center border rounded-full ${
            isFormValid ? "bg-green-500" : "bg-green-300 opacity-50 cursor-not-allowed"
          } text-white font-medium flex-none`}
        > 
            {responcetype === 'get_qoute' && (
              <span className="px-4 py-3">
                Get Qoute
              </span>
            )}
             {responcetype === 'book_now' && (
              <span className="px-4 py-3">
                Proceed To Payment
              </span>
            )}
             {responcetype === 'pay_later' && (
              <span className="px-4 py-3">
                Proceed To Payment
              </span>
            )}
         
          <span className="w-9 h-9 bg-white text-secondary flex justify-center items-center rounded-full me-1">
            <FaTelegramPlane color={"#63AB45"} />
          </span>
        </button>
        
        </div>
      </div>
    </>
  );
};

export default UserDetailsForm;
